var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_229_1",
    "data-name": "Component 229 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3774",
    "data-name": "Rectangle 3774",
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#353945"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33486",
    "data-name": "Path 33486",
    d: "M139.579,25.834a1,1,0,0,1-1.312,0l-2.592-2.325-2.592,2.325a1,1,0,0,1-1.312,0,.773.773,0,0,1,0-1.177l3.248-2.913a1,1,0,0,1,1.312,0l3.248,2.913A.773.773,0,0,1,139.579,25.834Z",
    transform: "translate(-119.955 -8.02)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowIcon);
export default __webpack_public_path__ + "static/media/blackArrowIcon.5998ffaf56bd7f2872c07b719564aa5e.svg";
export { ForwardRef as ReactComponent };